import { render } from "./RadixModule.vue?vue&type=template&id=00978d55"
import script from "./RadixModule.vue?vue&type=script&lang=js"
export * from "./RadixModule.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__